import { render, staticRenderFns } from "./AltDistrictSuccess.vue?vue&type=template&id=1334f75a&scoped=true&"
import script from "./AltDistrictSuccess.vue?vue&type=script&lang=js&"
export * from "./AltDistrictSuccess.vue?vue&type=script&lang=js&"
import style0 from "./AltDistrictSuccess.vue?vue&type=style&index=0&id=1334f75a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1334f75a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
